import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { usePasswordStrength } from "../../../common/hooks/usePasswordStrength";
import styles from "./PasswordStrengthIndicator.module.css";

/**
 * Visual password strength indicator component.
 * Shows strength text and colored bar based on password evaluation.
 *
 * @example
 * <PasswordStrengthIndicator password={password} />
 */
const PasswordStrengthIndicator = ({ password }) => {
  const { t } = useTranslation("common");
  const { strength } = usePasswordStrength(password);

  if (!password) return null;

  const getStrengthText = () => {
    switch (strength) {
      case "weak":
        return t("auth.resetPassword.weak");
      case "medium":
        return t("auth.resetPassword.medium");
      case "strong":
        return t("auth.resetPassword.strong");
      default:
        return "";
    }
  };

  return (
    <div className={styles.strengthIndicator}>
      <div>
        {t("auth.resetPassword.passwordStrength")}: <strong>{getStrengthText()}</strong>
      </div>
      <div className={styles.strengthBar}>
        <div className={`${styles.strengthFill} ${styles[strength]}`} />
      </div>
    </div>
  );
};

PasswordStrengthIndicator.propTypes = {
  password: PropTypes.string.isRequired,
};

export default PasswordStrengthIndicator;
